import React from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';

// Set the app element
Modal.setAppElement('#root');

class WhatsNewPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    componentDidMount() {
        const currentVersion = '1.0.5'; // Update this version number with each new release
        const hasSeenPopup = localStorage.getItem(`hasSeenWhatsNew_${currentVersion}`);
        if (!hasSeenPopup) {
            this.setState({ isOpen: true });
            localStorage.setItem(`hasSeenWhatsNew_${currentVersion}`, 'true');
        }
    }

    closeModal = () => {
        this.setState({ isOpen: false });
    };

    render() {
        return (
            <Modal
                isOpen={this.state.isOpen}
                onRequestClose={this.closeModal}
                className="whatsnew-popup"
            >
                <h2>What's New on Spike's Rewritten Guide</h2>
                <hr />
                <div>
                    Website search has been improved to get better results for all toons.
                </div>
                <hr />
                <div>
                    A new <Link to="/invasions" onClick={this.closeModal}>Invasion Tracker</Link> has been added to show current cog invasions by district.
                </div>
                <hr />
                <div>
                    A new <Link to="/fieldoffices" onClick={this.closeModal}>Field Office Tracker</Link> has been added to show current field offices.
                </div>
                <hr />
                <div>
                    See more updates on the <Link to="/whatsnew" onClick={this.closeModal}>What's New</Link> page!
                </div>
                <br />
                <br />
                <button onClick={this.closeModal}>Close</button>
            </Modal>
        );
    }
}

export default WhatsNewPopup;
